import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-monday-bg">
      <div className="flex flex-col items-center gap-3">
        <div className="animate-spin rounded-full h-10 w-10 border-[3px] border-monday-border-light border-t-primary-500" />
        <span className="text-sm text-monday-text-muted">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
